<div class="row align-items-center mb-2">
  <div>
    <button class="btn btn-outline-primary float-end" (click)="resetFilters()">Reset Filters</button>
  </div>
</div>
<div formLevelValidationErrors [errorEmitter]="errorEmitter" class="mb-2"></div>
<ag-grid-angular class="grid ag-theme-alpine" [gridOptions]="gridOptions" [rowData]="results" />
